(() => {
  function initSiteCart() {
    const drawer = document.querySelector('[data-viff-site-cart]');
    if (!drawer || drawer.dataset.ready || document.querySelector('[data-viff-wizard-root]')) return;
    drawer.dataset.ready = 'true';
    document.body.appendChild(drawer);
    const panel = drawer.querySelector('.vsc-panel');
    const lines = drawer.querySelector('[data-vsc-lines]');
    const status = drawer.querySelector('[data-vsc-status]');
    const total = drawer.querySelector('[data-vsc-total]');
    const checkout = drawer.querySelector('[data-vsc-checkout]');
    const clear = drawer.querySelector('[data-vsc-clear]');
    const shop = drawer.querySelector('[data-vsc-shop]');
    const stock = new Map(JSON.parse(drawer.querySelector('[data-vsc-stock]').textContent).map(v => [Number(v.id), v]));
    const route = (path) => (window.Shopify?.routes?.root || '/') + path.replace(/^\//, '');
    let currentCart = null;
    let busy = false;
    let returnFocus = null;
    let previousOverflow = '';

    const money = (amount) => new Intl.NumberFormat('en-GB', {style: 'currency', currency: currentCart?.currency || 'GBP'}).format(Number(amount) / 100);
    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    async function request(path, body) {
      const response = await fetch(route(path), {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: {'Accept': 'application/json', ...(body ? {'Content-Type': 'application/json'} : {})},
        ...(body ? {body: JSON.stringify(body)} : {})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not update your cart. Please try again.');
      return result;
    }

    function updateBubble(count) {
      const icon = document.getElementById('cart-icon-bubble');
      if (!icon) return;
      let bubble = icon.querySelector('.cart-count-bubble');
      if (!bubble && count > 0) {
        bubble = element('div', 'cart-count-bubble');
        const visible = element('span', '', count);
        visible.setAttribute('aria-hidden', 'true');
        bubble.append(visible, element('span', 'visually-hidden', count + ' items'));
        icon.append(bubble);
      }
      if (bubble) {
        bubble.style.display = count ? '' : 'none';
        const visible = bubble.querySelector('[aria-hidden="true"]');
        const hidden = bubble.querySelector('.visually-hidden');
        if (visible) visible.textContent = count;
        if (hidden) hidden.textContent = count + ' items';
      }
    }

    function render(cart) {
      currentCart = cart;
      updateBubble(cart.item_count);
      lines.replaceChildren();
      total.textContent = money(cart.total_price);
      status.textContent = cart.item_count === 1 ? '1 item ready for checkout.' : cart.item_count + ' items ready for checkout.';
      clear.hidden = !cart.item_count;
      shop.style.gridColumn = cart.item_count ? '' : '1 / -1';
      checkout.disabled = !cart.item_count;
      if (!cart.item_count) {
        const empty = element('div', 'vsc-empty');
        empty.append(element('strong', '', 'Your cart is empty.'), element('div', '', 'Build a pack and it will show here.'));
        lines.append(empty);
        return;
      }
      for (const item of cart.items) {
        const row = element('div', 'vsc-line');
        const image = element('img', 'vsc-image');
        if (item.image) image.src = item.image;
        image.alt = item.product_title || item.title;
        const main = element('div');
        const top = element('div', 'vsc-line-top');
        const price = element('span', 'vsc-price');
        const finalPrice = Number(item.final_line_price ?? item.line_price);
        if (Number(item.original_line_price ?? item.line_price) > finalPrice) price.append(element('s', '', money(item.original_line_price ?? item.line_price)));
        price.append(element('strong', '', money(finalPrice)));
        top.append(element('strong', 'vsc-line-title', item.product_title || item.title), price);
        const props = item.properties || {};
        const meta = [props.Pack, props.Stick, props.Aroma ? 'Scent: ' + props.Aroma : '', props.Colour ? 'Colour: ' + props.Colour : ''].filter(Boolean).join(' • ') || item.variant_title || '';
        const bottom = element('div', 'vsc-line-bottom');
        const qty = element('div', 'vsc-qty');
        const variant = stock.get(Number(item.variant_id));
        const aggregate = cart.items.filter(i => i.variant_id === item.variant_id).reduce((sum, i) => sum + i.quantity, 0);
        for (const [action, label, value] of [['minus', 'Decrease quantity', '−'], ['plus', 'Increase quantity', '+']]) {
          const button = element('button', '', value);
          button.type = 'button';
          button.dataset.vscAction = action;
          button.dataset.key = item.key;
          button.setAttribute('aria-label', label + ' for ' + (item.product_title || item.title) + ', ' + (item.variant_title || 'selected stick'));
          button.disabled = action === 'minus' ? item.quantity <= 1 : Boolean(variant && (!variant.available || (variant.managed && variant.policy === 'deny' && aggregate >= variant.quantity)));
          if (action === 'plus') qty.append(element('span', '', item.quantity));
          qty.append(button);
        }
        const remove = element('button', 'vsc-delete', 'Delete');
        remove.type = 'button';
        remove.dataset.vscAction = 'remove';
        remove.dataset.key = item.key;
        remove.setAttribute('aria-label', 'Delete ' + (item.product_title || item.title) + ', ' + (item.variant_title || 'selected stick'));
        bottom.append(qty, remove);
        main.append(top, element('span', 'vsc-meta', meta), bottom);
        row.append(image, main);
        lines.append(row);
      }
    }

    async function refresh() {
      busy = true;
      checkout.disabled = true;
      clear.disabled = true;
      status.textContent = 'Loading your cart…';
      try { render(await request('cart.js')); }
      catch (error) { status.textContent = error.message; }
      finally { busy = false; clear.disabled = false; }
    }

    function close() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      document.body.style.overflow = previousOverflow;
      returnFocus?.focus();
    }

    async function change(key, quantity) {
      if (busy || !currentCart) return;
      const item = currentCart.items.find(i => i.key === key);
      if (!item) return;
      const variant = stock.get(Number(item.variant_id));
      const aggregate = currentCart.items.filter(i => i.variant_id === item.variant_id).reduce((sum, i) => sum + i.quantity, 0);
      if (quantity > item.quantity && variant && (!variant.available || (variant.managed && variant.policy === 'deny' && aggregate - item.quantity + quantity > variant.quantity))) {
        status.textContent = 'That colour and scent do not have enough stock. Please choose a smaller quantity.';
        return;
      }
      busy = true;
      checkout.disabled = true;
      clear.disabled = true;
      lines.querySelectorAll('button').forEach(b => { b.disabled = true; });
      status.textContent = 'Updating your cart…';
      try { render(await request('cart/change.js', {id: key, quantity})); }
      catch (error) {
        try { render(await request('cart.js')); } catch (_) {}
        status.textContent = error.message;
      }
      finally { busy = false; clear.disabled = false; }
    }

    document.addEventListener('click', event => {
      if (!drawer.isConnected || document.querySelector('[data-viff-wizard-root]')) return;
      const link = event.target.closest('a');
      if (!link || drawer.contains(link)) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || (link.id !== 'cart-icon-bubble' && url.pathname.replace(/\/$/, '') !== route('cart').replace(/\/$/, ''))) return;
      event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
      if (drawer.hidden) {
        returnFocus = link;
        previousOverflow = document.body.style.overflow;
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
        drawer.querySelector('.vsc-close').focus();
      }
      refresh();
    }, true);

    drawer.addEventListener('click', event => {
      if (event.target.closest('[data-vsc-close]')) return close();
      const control = event.target.closest('[data-vsc-action]');
      if (!control || busy || !currentCart) return;
      const item = currentCart.items.find(i => i.key === control.dataset.key);
      if (item) change(item.key, control.dataset.vscAction === 'remove' ? 0 : item.quantity + (control.dataset.vscAction === 'plus' ? 1 : -1));
    });

    clear.addEventListener('click', async () => {
      if (busy) return;
      busy = true; clear.disabled = true; checkout.disabled = true;
      status.textContent = 'Emptying your cart…';
      try { render(await request('cart/clear.js', {})); }
      catch (error) { status.textContent = error.message; checkout.disabled = !currentCart?.item_count; }
      finally { busy = false; clear.disabled = false; }
    });
    checkout.addEventListener('click', () => { if (!busy && currentCart?.item_count) window.location.href = route('checkout'); });
    document.addEventListener('keydown', event => {
      if (drawer.hidden || !drawer.isConnected) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key === 'Tab') {
        const focusable = Array.from(panel.querySelectorAll('button:not(:disabled),a[href]')).filter(n => !n.hidden && n.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSiteCart);
  else initSiteCart();
  document.addEventListener('shopify:section:load', initSiteCart);
})();
